import { render, staticRenderFns } from "./MyTransfer.vue?vue&type=template&id=323c2d57&"
import script from "./MyTransfer.vue?vue&type=script&lang=js&"
export * from "./MyTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports